import { forwardRef } from 'react';
import { CircularProgress } from '@mui/material';
import cn from 'classnames';

import { Content, LoaderWrapper, MuiButtonStyled } from './styled';
import { TMplButtonProps } from './types';

export const MplButton = forwardRef<HTMLButtonElement, TMplButtonProps>(
	(
		{ className, children, showLoader, testId = 'mplButton', ...muiProps },
		ref
	) => (
		<MuiButtonStyled
			className={cn(className, showLoader && 'loading')}
			disableFocusRipple
			data-testid={testId}
			ref={ref}
			{...muiProps}
		>
			<Content hide={showLoader}>{children}</Content>
			{showLoader && (
				<LoaderWrapper>
					<CircularProgress size={16} color="inherit" />
				</LoaderWrapper>
			)}
		</MuiButtonStyled>
	)
);

MplButton.displayName = 'MplButton';
